import { render, staticRenderFns } from "./exchange-list.vue?vue&type=template&id=47315349&scoped=true&lang=pug&"
import script from "./exchange-list.vue?vue&type=script&lang=js&"
export * from "./exchange-list.vue?vue&type=script&lang=js&"
import style0 from "./exchange-list.vue?vue&type=style&index=0&id=47315349&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47315349",
  null
  
)

export default component.exports